import { Stack, Typography, Checkbox, CheckboxProps } from "components";

interface CheckboxGroupProps extends Omit<CheckboxProps, "value"> {
  options: string[];
  defaults?: (string | undefined)[];
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  name: nameProp,
  type = "checkbox",
  label,
  options,
  defaults,
  readOnly,
  style,
}) => (
  <Stack direction="column" gap={0.5} style={style}>
    <Typography
      size={-1}
      color="#757575"
      style={{ textTransform: "capitalize" }}
    >
      {label}
    </Typography>
    <Stack gap={2}>
      {options.map((option, index) => {
        let name = nameProp;

        if (type === "checkbox") {
          name += index + 1;
        }

        return (
          <Checkbox
            key={option}
            name={name}
            value={option}
            type={type}
            capitalize
            defaultChecked={defaults && defaults.includes(option)}
            readOnly={readOnly}
          >
            {option}
          </Checkbox>
        );
      })}
    </Stack>
  </Stack>
);

export type { CheckboxGroupProps };
export { CheckboxGroup };
